<form [formGroup]="form">
  <ix-textarea
    formControlName="certificate"
    [label]="'Certificate' | translate"
    [required]="true"
    [tooltip]="helptext.add.certificate.tooltip | translate"
  ></ix-textarea>

  <ix-textarea
    formControlName="privatekey"
    [label]="'Private Key' | translate"
    [tooltip]="helptext.add.privatekey.tooltip | translate"
  ></ix-textarea>

  <ix-input
    formControlName="passphrase"
    type="password"
    [label]="'Passphrase' | translate"
    [tooltip]="helptext.add.passphrase.tooltip | translate"
  ></ix-input>

  <ix-input
    formControlName="passphrase2"
    type="password"
    [label]="'Confirm Passphrase' | translate"
  ></ix-input>

  <ix-form-actions>
    <button
      mat-button
      matStepperPrevious
      ixTest="back"
    >{{ 'Back' | translate }}</button>
    <button
      mat-button
      matStepperNext
      color="primary"
      ixTest="next"
      [disabled]="form.invalid"
    >{{ 'Next' | translate }}</button>
  </ix-form-actions>
</form>
